import { useSnapshots } from 'features/snapshots/api/getSnapshots';
import { checkIfAnalyzerInCrosspolMode } from '../utils';

export const useIsAnalyzerInCrosspolMode = (analyzerId: number) => {
  const { data: snapshots } = useSnapshots({
    analyzerId,
    config: { keepPreviousData: true },
  });

  return checkIfAnalyzerInCrosspolMode(snapshots);
};
